<template>
    <div class="prelative developer-page">
        <header class="flex-level mb-4 top--2 baseline">
            <h2 class="m-0" v-if="groupData.label && groupData.label !== ''">
                <slot name="header">{{ groupData.label }}</slot>
            </h2>

            <div class="ml-4">
                <tabs-nav
                :tabs="tabs"
                :activeTab="activeListing"
                @tab-clicked="handleSelect"
                />
            </div>
        </header>

        <div class="flex-column">
            <router-view :key="$route.path" v-if="!loading"></router-view>
        </div>
    </div>
</template>

<script>
import Feature from "Services/Feature";
import TabsNav from "vcomponents/utilities/TabsNav.vue";
import CorpId from 'vcomponents/developerPage/CorpId.vue'

export default {
    props: {
        initialState: {
        type: String,
        required: false,
        default: "my-apps",
        validator(val) {
            return [
            "my-apps",
            "api-v2",
            "third-party-apps",
            "webhooks",
            "widgets",
            ].includes(val);
        },
        },
    },
    data() {
        return {
            loading: false,
            groupData: { label: this.$l10n.__("Développeur") },
        };
    },
    created() {
        this.activeListing = this.$route.name;
    },
    computed: {
        tabs() {
            let tabs = [
                {
                id: "my-apps",
                label: this.$l10n.__("API"),
                route: "my-apps",
                permission: "",
                },
                {
                id: "third-party-apps",
                label: this.$l10n.__("Applications"),
                route: "third-party-apps",
                permission: "",
                },
                {
                id: "webhooks",
                label: this.$l10n.__("Webhooks"),
                route: "webhooks",
                permission: "",
                },
                {
                id: "widgets",
                label: this.$l10n.__("Widgets"),
                route: "widgets",
                permission: "",
                },
            ];

            if (Feature.isEnabled("api-v2")) {
                tabs.splice(1, 0, {
                id: "api-v2",
                label: this.$l10n.__("API V2 (bêta)"),
                route: "api-v2",
                permission: "",
                });
            }

            return tabs;
        },
    },
    methods: {
        handleSelect(key) {
            let listingData = this.tabs.find((listing) => listing.id === key);
            if (listingData.route != this.$router.currentRoute.name) {
                this.activeListing = key;
                // you can pass special props to your component with params in second paramter of the route
                // this.$router.push({ name: listingData.route, params: {prefilter: {staff : 2}}})
                this.$router.push({ name: listingData.route });
            }
        },
    },
    components: {
        TabsNav,
        CorpId
    },
};
</script>

<style lang="scss">
    .developer-page {
        .header-actions {
            align-items: center;
            display: flex;
            position: absolute;
            right: 0;
            top: 12px;

            .el-dropdown,
            .btn {
                margin: 0 0 0 16px;
            }
        }
    }
</style>